import { useMemo } from 'react';

import { useDisplayTimeZone } from '@hooks/useDisplayTimeZone';

import { DatePickerFormat, displayFormats, formatInTimeZone } from '@utils/format-time';

export const useFormatDate = () => {
  const { timeZone } = useDisplayTimeZone();

  return useMemo(() => {
    const format = (date: DatePickerFormat, template: string) => formatInTimeZone(date, timeZone, template);

    return {
      timeZone,
      format,
      /** Sep 10, 2026 */
      formatDate: (date: DatePickerFormat) => format(date, displayFormats.date),
      /** 9:52 AM */
      formatTime: (date: DatePickerFormat) => format(date, displayFormats.time),
      /** 09:52:07 AM */
      formatLongTime: (date: DatePickerFormat) => format(date, displayFormats.longTime),
      /** Thu Sep 10, 2026 */
      formatTableDate: (date: DatePickerFormat) => format(date, displayFormats.tableDate),
      /** Thu Sep 10 2026, 9:52 AM */
      formatDateTime: (date: DatePickerFormat) => format(date, displayFormats.dateTime),
    };
  }, [timeZone]);
};
